export const SELF_ASSIGN_NOT_PERMITTED_MESSAGE =
  'License assignment is managed by your workspace admin. Ask an admin to assign you a license.';

export const SELF_ASSIGN_NO_OPTIONS_MESSAGE =
  'No subscription in this workspace has licenses available. Contact your workspace admin.';
